import { render, staticRenderFns } from "./appMenu.vue?vue&type=template&id=084ac99e&scoped=true"
import script from "./appMenu.vue?vue&type=script&lang=js"
export * from "./appMenu.vue?vue&type=script&lang=js"
import style0 from "./appMenu.vue?vue&type=style&index=0&id=084ac99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ac99e",
  null
  
)

export default component.exports